<template>  
    <div class="header-wrap">
        <div class="wrapCenter">
            <nav class="navbar navbar-default" role="navigation">
                <div class="container-fluid">
                <div class="navbar-header">
                    <button type="button" class="navbar-toggle" data-toggle="collapse"
                            data-target="#example-navbar-collapse">
                        <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
                    </button>
                    <!-- LOGO -->
                    <div class="header-logo">
                        <!--<router-link :to="{path: '/'}" class="header-logo-link"></router-link>-->
                        <a href="/" class="header-logo-link"></a>
                    </div>
                </div>
                <div class="collapse navbar-collapse" id="example-navbar-collapse">
                    <!-- 菜单 -->
                    <ul class="header-link nav navbar-nav">
                        <li v-for="(item, index) in menus" :key="index">
                            <router-link :to="{path: item.url}" :class="{'active': $route.path == item.url}"> {{item.name}} 
                            </router-link>
                        </li>
                    </ul>
                </div>
                </div>
            </nav>
            
        </div>
        
    </div>
    
</template>
<script>
    export default {
        data() {
            return {
                menus: [{
                    name: "有线耳机",
                    url: "/earphoneList",
                }, {
                    name: "蓝牙耳机",
                    url: "/earphoneListBlue"
                }, {
                    name: "关于唐麦",
                    url: "/about/top"
                // }, {
                //     name: "服务与支持",
                //     url: "/server"
                }]
            }
        }
    }
</script>
<style scoped>
    .wrapCenter{
        width: 1100px;
    }
    .header-wrap {
        position: fixed;
        height: 80px;
        width: 100%;
        background: #1d191a;
        z-index: 10;
        top: 0px;
    }
    
    .header-logo {
        display: inline;
        float: left;
        padding: 20px 0;
    }
    
    .header-logo-link {
        display: block;
        width: 140px;
        height: 40px;
        background-repeat: no-repeat;
        background-position: center center;
        background-image: url(../assets/img/logo4.png);
        background-size: contain;
    }
    
    .header-link {
        display: inline;
        float: right;
        white-space: nowrap;
    }
    
    .header-link li {
        display: inline;
        float: left;
    }
    
    .header-link a {
        display: block;
        padding: 30px 30px;
        line-height: 20px;
        transition: color .1s linear;
    }
    
    .header-link a.active {
        color: #ffffff;
    }
    
    .header-link-arrow {
        display: inline-block;
        width: 6px;
        height: 6px;
        border-right: 3px #313131 solid;
        border-bottom: 3px #313131 solid;
        transform: rotate(45deg) translate(0, -2px);
        margin-left: 2px;
    }
    .navbar-default .navbar-nav>li>a{
        color: #ffffff;
    }
    .navbar {
        border: none;
    }
    
    .navbar-default {
        background: #1d191a;
    }
    
    .navbar-default .navbar-collapse,
    .navbar-default .navbar-form {
        background: #1d191a;
    }
    
    .navbar {
        position: static;
    }
    
    .nav>li {
        position: static;
    }
    
    .dropdown-menu {
        min-width: 100%;
        width: 100%;
        left: 0px;
        border: none;
        border-top: 1px #e7e7e7 solid;
        display: block;
        background: rgba(255, 255, 255, 0.4);
    }
    
    .dropdown-menu li {
        float: left;
    }
    
    .dropdown-menu li a {
        padding: 4px 10px;
    }
    
    .navbar-default .navbar-nav>li>a:focus, .navbar-default .navbar-nav>li>a:hover
    
    .navbar-nav>li:hover .header-link-arrow {
        /* border-color: #0044bc; */
    }
    /*.navbar-nav>li:hover .dropdown-menu{
        display: block;
    }*/
    
    .navbar-nav>li>.dropdown-menu>ul {
        /* float: right; */
        left: 50%; 
        position: relative;
    }
    
    .navbar-nav>li>.dropdown-menu>ul>li:hover a,
    .navbar-nav>li>.dropdown-menu>ul>li.active a {
        color: #ffffff;
    }
    
    @media (max-width: 768px) {
        .container-fluid {
            padding: 0px;
        }
        .header-wrap {
            height: 60px;
        }
        .navbar-header {
            height: 60px;
            margin: 0;
            padding: 0 1rem;
        }
        .header-logo {
            left: 50%;
            position: absolute;
            margin-left: -2.5rem;
            padding: 10px 0;
        }
        .header-logo-link {
            width: 130px;
            height: 40px;
            background-size: contain;
        }
        .navbar-toggle {
            float: left;
            margin-top: 14px;
        }
        .navbar {
            margin-bottom: 0px;
        }
        .navbar-default .navbar-toggle .icon-bar {
            background: #ffffff;
            height: 3px;
        }
        .navbar-default .navbar-toggle {
            border: none;
        }
        .navbar-nav {
            margin: 7.5px 0px 0px 0px;
        }
        .header-link {
            float: none;
            display: block;
        }
        .header-link li {
            float: none;
            display: block;
            width: 100%;
            overflow: hidden;
        }
        .header-link a {
            padding: 16px 1.4rem;
            border-bottom: 1px #333333 solid;
        }
        .navbar-nav>li>.dropdown-menu>ul {
            float: none;
            margin-right: 0px !important;
        }
        .dropdown-menu li a {
            padding: 16px 1.4rem;
        }
        .dropdown-menu {
            position: relative;
            background: rgba(255, 255, 255, 0.3);
        }
        .navbar-collapse {
            margin-left: 0px;
            margin-right: 0px;
            padding-left: 0px;
            padding-right: 0px;
        }
        .navbar-default .navbar-toggle:focus,
        .navbar-default .navbar-toggle:hover {
            background: none;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/header2.vue